import { Card } from "@/components/ui/card";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

interface TransactionCountBarChartProps {
  transactions: any[];
}

export const TransactionCountBarChart = ({ transactions }: TransactionCountBarChartProps) => {
  const transactionsByDate = transactions.reduce((acc: any, transaction) => {
    const date = format(new Date(transaction.created_at), 'P', { locale: fr });
    if (!acc[date]) {
      acc[date] = {
        date,
        transactions: 0,
      };
    }
    acc[date].transactions += 1;
    return acc;
  }, {});

  const barChartData = Object.values(transactionsByDate);

  return (
    <Card className="p-4">
      <h3 className="text-lg font-semibold mb-4">Nombre de transactions par jour</h3>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={barChartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="transactions"
              fill="#8884d8"
              name="Nombre de transactions"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};